import styled from 'styled-components';
import { DatePickerSelectMixin } from '../../mixins/components/DatePickerSelectMixin';
export var StyledDatePickerSelect = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledDatePickerSelect",
  componentId: "c11n-8-111-1__sc-1y0so0n-0"
})(["", ""], DatePickerSelectMixin);